export default __webpack_public_path__ + "static/media/29t.e638909e.jpg";